import React, { useEffect, useRef } from "react";
import ModalWrapper from "../../../../../../Components/Modals/ModalWrapper";

// Adds what the shared ModalWrapper leaves out: Escape to close, dialog
// semantics for screen readers, focus moved into the dialog, and focus
// handed back to whatever opened it.
const StoreDialog = ({ open, onClose, label, children }) => {
  const dialogRef = useRef(null);
  // Parents pass inline handlers; reading through a ref keeps the effect from
  // re-running (and stealing focus from inputs) on every render.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const opener = document.activeElement;
    dialogRef.current?.focus();
    const onKeyDown = (e) => {
      if (e.key === "Escape") onCloseRef.current();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      opener?.focus?.();
    };
  }, [open]);

  return (
    <ModalWrapper
      isOpen={open}
      onClose={onClose}
      boxClassName="flex max-h-[calc(100vh-40px)] !w-full max-w-[520px] flex-col overflow-auto !rounded-[14px] !p-0 shadow-soft-2xl"
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-label={label}
        tabIndex={-1}
        className="flex flex-col outline-none"
      >
        {children}
      </div>
    </ModalWrapper>
  );
};

export const SECONDARY_BUTTON =
  "h-9 rounded-lg border-[1px] border-ui-border bg-ui-surface px-3.5 text-[13px] font-medium text-ui-text-secondary hover:bg-ui-surface-sunken";

export const PRIMARY_BUTTON =
  "flex h-9 items-center justify-center rounded-lg border-[1px] border-brand bg-brand px-[16px] text-[13px] font-medium text-brand-contrast hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-50";

// items-stretch and min-w-0 undo a global `label` rule in
// styles/shared/stripe-credit-card-form.css (align-items: center;
// min-width: 105px) that otherwise centres the text and shrinks the inputs.
export const FIELD_LABEL =
  "flex min-w-0 flex-col items-stretch gap-1.5 text-left";

export const FIELD_CLASS =
  "rounded-lg border-[1px] border-ui-border-strong bg-ui-surface px-[12px] text-[13px] text-ui-text outline-none transition-shadow placeholder:text-ui-text-subtle focus:border-brand focus:shadow-[0_0_0_3px_var(--color-brand-light)]";

export default StoreDialog;
